import React from 'react';

interface RobotIconProps {
  size?: number;
  className?: string;
}

export const RobotIcon: React.FC<RobotIconProps> = ({ size = 16, className = "" }) => {
  // Versión optimizada: sin ruido visual, legible en pequeño, sin sombras complejas.
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      shapeRendering="crispEdges"
    >
      {/* Cabeza */}
      <rect x="6" y="3" width="12" height="8" rx="2" fill="currentColor" />
      {/* Ojos */}
      <rect x="8.5" y="5.5" width="2" height="2" rx="0.5" fill="white" />
      <rect x="13.5" y="5.5" width="2" height="2" rx="0.5" fill="white" />
      
      {/* Cuerpo */}
      <rect x="5" y="12" width="14" height="9" rx="2" fill="currentColor" />
      {/* Panel en el pecho */}
      <rect x="8" y="14" width="8" height="4" rx="1" fill="white" fillOpacity="0.2" />
      
      {/* Antenas / Orejas simplificadas */}
      <rect x="4" y="13" width="1.5" height="5" rx="0.75" fill="currentColor" />
      <rect x="18.5" y="13" width="1.5" height="5" rx="0.75" fill="currentColor" />
    </svg>
  );
};
